<template>
    <!-- PC -->
    <div v-if="!mobile">
        <div>
            <div class="lkt-manual env_VN">
                <div><p>①　Truy cập vào link study-arts.vn bằng Safari/Chrome/Firefox từ điện thoại.</p></div>
                <div><img src="/static\images\vi\newManual\mobile\pwa_1.png" alt="" /></div>
                <div><p>②　Mở【Add to Home Screen】ra để thêm icon vào màn hình chính.</p></div>
                <div><p>■ Safari</p></div>
                <div><p>・Khi nhấn vào icon như bên dưới ở chính giữa thanh công cụ phía dưới màn hình, thì màn hình như hình bên phải sẽ được hiển thị.</p></div>
                <div><p>・Khi nhấn vào icon【Add to Home Screen】, thì việc cài đặt「StudyArts」sẽ hoàn thành.</p></div>
                <div><img src="/static\images\vi\newManual\mobile\pwa_2_1.png" alt="" /></div>
                <div><p>■ Chrome</p></div>
                <div><p>・Khi nhấn vào biểu tượng dấu 3 chấm dọc, thì menu sẽ được hiển thị từ bên phải màn hình.</p></div>
                <div><p>・Khi nhấn vào icon[Add to Home screen] ỏ trên thanh menu thì, màn hình popup「Add to Home screen」sẽ được hiển thị.</p></div>
                <div><p>・Khi nhấn vào nút【Add】ở trên màn hình popup của「Add to Home screen」,sẽ di chuyển đến màn hình popup như bên dưới.</p></div>
                <div><p>・Khi nhấn vào nút【Add Automatically】, thì「StudyArts」dùng cho điện thoại sẽ được cài đặt.</p></div>
                <div><img src="/static\images\vi\newManual\mobile\pwa_2_2.png" alt="" /></div>
                <div><p>■ Firefox</p></div>
                <div><p>・Khi nhấn vào biểu tượng dấu 3 chấm dọc, thì menu sẽ được hiển thị từ phía bên phải màn hình.</p></div>
                <div><p>・Khi nhấn vào icon [Cài đặt] ở trên thanh menu, thì「StudyArts」sẽ được cài đặt.</p></div>
                <div><img src="/static\images\vi\newManual\mobile\pwa_2_3.png" alt="" /></div>
            </div>
        </div>
    </div>
    <!-- Mobile -->
    <div v-else>
        <div>
            <div class="lkt-manual env_VN">
                <div><p>①　Truy cập vào link study-arts.vn bằng Safari/Chrome/Firefox từ điện thoại.</p></div>
                <div><img src="/static\images\vi\newManual\mobile\pwa_1.png" alt="" /></div>
                <div><p>②　Mở【Add to Home Screen】ra để thêm icon vào màn hình chính.</p></div>
                <div><p>■ Safari</p></div>
                <div><p>・Khi nhấn vào icon như bên dưới ở chính giữa thanh công cụ phía dưới màn hình, thì màn hình như hình bên phải sẽ được hiển thị.</p></div>
                <div><p>・Khi nhấn vào icon【Add to Home Screen】, thì việc cài đặt「StudyArts」sẽ hoàn thành.</p></div>
                <div><img src="/static\images\vi\newManual\mobile\pwa_2_1.png" alt="" /></div>
                <div><p>■ Chrome</p></div>
                <div><p>・Khi nhấn vào biểu tượng dấu 3 chấm dọc, thì menu sẽ được hiển thị từ bên phải màn hình.</p></div>
                <div><p>・Khi nhấn vào icon[Add to Home screen] ỏ trên thanh menu thì, màn hình popup「Add to Home screen」sẽ được hiển thị.</p></div>
                <div><p>・Khi nhấn vào nút【Add】ở trên màn hình popup của「Add to Home screen」,sẽ di chuyển đến màn hình popup như bên dưới.</p></div>
                <div><p>・Khi nhấn vào nút【Add Automatically】, thì「StudyArts」dùng cho điện thoại sẽ được cài đặt.</p></div>
                <div><img src="/static\images\vi\newManual\mobile\pwa_2_2.png" alt="" /></div>
                <div><p>■ Firefox</p></div>
                <div><p>・Khi nhấn vào biểu tượng dấu 3 chấm dọc, thì menu sẽ được hiển thị từ phía bên phải màn hình.</p></div>
                <div><p>・Khi nhấn vào icon [Cài đặt] ở trên thanh menu, thì「StudyArts」sẽ được cài đặt.</p></div>
                <div><img src="/static\images\vi\newManual\mobile\pwa_2_3.png" alt="" /></div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {};
        },
        components: {},
        computed: {
            mobile() {
                return this.$store.getters["header/mobile"];
            },
        },
        async created() {},
        watch: {},
        methods: {
            scrollToElement(id) {
                let element = document.getElementById(id);
                element.scrollIntoView();
            },
        },
    };
</script>
<style scoped>
    .lkt-manual div {
        margin-bottom: 10px;
    }
    .lkt-manual p {
        line-height: 25px;
    }
    .lkt-manual ul {
        margin-left: 20px;
        list-style: square;
        font-size: 12pt;
    }
    ul li {
        cursor: pointer;
    }
    img {
        width: 100%;
    }
    p {
        font-size: 16px;
    }
</style>



// WEBPACK FOOTER //
// src/components/manual/content/vi/pwa_manual.vue